import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.scss';
import aboutImage from '../assets/about.jpeg';

const AboutPage = () => {
    return (
        <div className="about-page">
            <div className="about-hero">
                <h1>About CHAIropractic</h1>
                <p>We are not a 'crack-and-go' clinic. Your healing requires time, which is why every visit is a focused 30-45 minute <br />session covering adjustments, hands-on soft tissue therapy, and personalized rehabilitation.</p>
            </div>

            <div className="about-content">
                <section className="our-story">
                    <div className="content-wrapper">
                        <div className="text-content">
                            <h2>Dr. Issac Chai, DC</h2>
                            <p>
                                Born in Seoul, South Korea, Dr. Issac Chai moved to Seattle, WA at age 8. 
                                Growing up, he played competitive soccer and football, earning All-Conference honors in varsity soccer. 
                                After experiencing several injuries throughout over a decade of competitive sports, 
                                and receiving care from athletic trainers and doctors, he discovered a passion for helping others overcome pain. 
                                That passion was solidified during a high school sports medicine course, where he first became interested in the medical field.
                            </p>
                            <p>
                                He went on to study kinesiology at San Diego State University and later earned his Doctorate of Chiropractic from Southern California University of Health Sciences. 
                                Dr. Chai now combines his athletic background with clinical training at CHAIropractic™, where he provides personalized, movement-based care to help patients live pain-free and stay active.
                            </p>
                        </div>
                        <div className="image-content">
                            <div className="image-placeholder">
                                <img
                                    src={aboutImage}
                                    alt="Dr. Issac Chai"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <section className="our-mission">
                    <h2>Our Mission</h2>
                    <div className="mission-grid">
                        <div className="mission-item">
                            <div className="mission-icon">🎯</div>
                            <h3>Patient-Centered Care</h3>
                            <p>Every treatment plan is designed with your unique needs and goals in mind</p>
                        </div>
                        <div className="mission-item">
                            <div className="mission-icon">🔬</div>
                            <h3>Evidence-Based Practice</h3>
                            <p>Using the latest research and proven techniques for optimal results</p>
                        </div>
                        <div className="mission-item">
                            <div className="mission-icon">💚</div>
                            <h3>Holistic Wellness</h3>
                            <p>Addressing the root cause to promote long-term health and vitality</p>
                        </div>
                        <div className="mission-item">
                            <div className="mission-icon">🤝</div>
                            <h3>Compassionate Service</h3>
                            <p>Treating every patient with respect, empathy, and dedication</p>
                        </div>
                    </div>
                </section>

                <section className="why-choose-us">
                    <h2>Why Choose CHAIropractic?</h2>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <div className="benefit-number">COX® Technic</div>
                            <h3>Obtained Speciality</h3>
                            <p>Non-Surgical, Reliable Treatment Method for <br/>Disc related Conditions</p>
                        </div>
                        <div className="benefit-item">
                            <div className="benefit-number">30-45 Min</div>
                            <h3>Focused Sessions</h3>
                            <p>Combining hands-on therapy, Soft tissue work, and various passive modalities</p>
                        </div>
                        <div className="benefit-item">
                            <div className="benefit-number">100%</div>
                            <h3>Personalized Care</h3>
                            <p>Custom treatment plans for every individual patient</p>
                        </div>
                        <div className="benefit-item">
                            <div className="benefit-number">💚</div>
                            <h3>Comprehensive Approach</h3>
                            <p>Addressing the whole person, not just symptoms</p>
                        </div>
                    </div>
                </section>

                <section className="our-philosophy">
                    <h2>Our Philosophy</h2>
                    <div className="philosophy-content">
                        <p>
                            At CHAIropractic, we believe you deserve more than a quick, 
                            "crack-and-go" solution. Our philosophy centers on quality time and specialized expertise. 
                            Every patient receives a comprehensive 30-45 minute session dedicated 
                            to finding the lasting structural solution to their pain. 
                            We utilize evidence-based spine methods, including 
                            the COX® Flexion-Distraction Technic, to precisely correct the underlying issue. 
                            This holistic approach ensures we combine focused adjustments with necessary 
                            hands-on therapy and modalities, helping you achieve functional independence, 
                            not just temporary relief.
                        </p>
                    </div>
                </section>
            </div>

            <div className="cta-banner">
                <h2>Start Your Lasting Recovery Today!</h2>
                <p>Schedule your consultation today and discover how we can help you achieve better health</p>
                <Link to="/contact" className="btn-primary-large">Call Now</Link>
            </div>
        </div>
    );
};

export default AboutPage;

